module.exports = __webpack_public_path__ + "img/downloadSvg2.8e93743a.svg";